var cifId = ["301 201", "<g fill='none'><path fill='#CE1126' d='M.5.5h300v200H.5z'/><path fill='#FFF' d='M.5 100.5h300v100H.5z'/></g>"];

export { cifId };

